import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-field-filter',
  templateUrl: './field-filter.component.html',
  styleUrls: ['./field-filter.component.scss']
})
export class FieldFilterComponent implements OnInit, OnChanges {

  @Input() fieldValue: any;
  @Input() colors: any[];
  @Output() toggle = new EventEmitter();

  minValue: number;
  maxValue: number;

  range: number[];

  activeAll: boolean;

  constructor() { }

  ngOnInit() {}

  ngOnChanges() {
    if (this.fieldValue.field.type === 'numeric') {
      this.minValue = _.min(this.fieldValue.values.map(v => +v.value));
      this.maxValue = _.max(this.fieldValue.values.map(v => +v.value));

      let from, to;

      if (!this.fieldValue.field.min) {
        from = this.minValue;
      } else if (this.fieldValue.field.min < this.minValue) {
        from = this.minValue;
      } else {
        from = this.fieldValue.field.min;
      }

      if (!this.fieldValue.field.max) {
        to = this.maxValue;
      } else if (this.fieldValue.field.max > this.maxValue) {
        to = this.maxValue;
      } else {
        to = this.fieldValue.field.max;
      }

      this.range = [from, to];

    } else {
      this.activeAll = this.fieldValue.values.every(v => v.active);
    }
  }

  getBackground(value) {
    if (!this.colors) {
      return '#fff';
    } else {
      const colorVal = this.colors.find(c => c.id === value._id);
      return colorVal && colorVal.color || '#fff';
    }
  }

  onRangeChange(data) {
    this.fieldValue.field.min = data[0];
    this.fieldValue.field.max = data[1];
    this.toggle.next();
  }

  toggleTextFilter(e) {
    this.activeAll = !this.activeAll;
    this.fieldValue.values.forEach(v => {
      v.active = this.activeAll;
    });
    e.preventDefault();
    this.toggle.next();
  }

  toggleValue(value) {
    value.active = !value.active;
    this.activeAll = this.fieldValue.values.every(v => v.active);
    this.toggle.next();
  }

  toggleNumberFilter() {
    this.fieldValue.field.min = null;
    this.fieldValue.field.max = null;
    this.range = [this.minValue, this.maxValue];
    this.toggle.next();
  }

  isNumber() {
    return this.fieldValue.field.type === 'numeric';
  }

}



// WEBPACK FOOTER //
// ./client/app/components/visualize/field-filter/field-filter.component.ts